import { isEmpty, map } from 'lodash/fp';
import { connect } from 'react-redux';
import {
    getLocalizedTaxRatesOptions,
    getTaxationsByTaxEnvironmentCode,
} from '@mews-commander/legacy-entities/src/ducks/taxEnvironments';
import { ApplicationState, Taxation, TaxRateStrategyDiscriminator } from '@mews-commander/types';
import { FieldSet } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { Stack } from '@optimus-web/core';
import { SelectField } from '../reduxFields';

interface TaxationFieldsOwnProps {
    taxEnvironmentCode: string;
    label: React.ReactNode;
    name: string;
    showEmptyValue?: boolean;
    disabled?: boolean;
    id?: string;
}

interface TaxationFieldsStateProps {
    taxations: Array<Taxation>;
}

const TaxationSelectFields: React.FC<React.PropsWithChildren<TaxationFieldsOwnProps & TaxationFieldsStateProps>> = ({
    taxations,
    label,
    name: fieldName,
    ...other
}) => {
    if (isEmpty(taxations)) {
        return null;
    }

    return (
        <FieldSet label={label}>
            <Stack distribution="stretch" vertical spacing="200">
                {map(({ code, taxRates, name: taxationName }) => (
                    <SelectField
                        key={code}
                        suffix={
                            taxRates[0].strategy.discriminator === TaxRateStrategyDiscriminator.Flat
                                ? taxRates[0].strategy.value.currencyCode
                                : UnicodeEntity.Percent
                        }
                        label={taxationName}
                        name={`${fieldName}.${code}`}
                        options={getLocalizedTaxRatesOptions(taxRates)}
                        {...other}
                    />
                ))(taxations)}
            </Stack>
        </FieldSet>
    );
};

export default connect<TaxationFieldsStateProps, {}, TaxationFieldsOwnProps, ApplicationState>(
    (state, { taxEnvironmentCode }) => ({
        taxations: getTaxationsByTaxEnvironmentCode(state, { taxEnvironmentCode }),
    })
)(TaxationSelectFields);
